// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PPmM","controls":"styles_controls__1xnF4","charLimit":"styles_charLimit__2rTck","input":"styles_input__1Dy-A","send":"styles_send__3CInZ"};